import { Grid, Typography } from "@mui/material";
import { useMediaQuery } from "@mui/system";
import { specialistRequests } from "api/specialistApi";
import { settings } from "app";
import { administrationRequests } from "api/administrationApi";
import { useCallback, useEffect, useState } from "react";
import {
  ArrayField,
  Datagrid,
  Labeled,
  RecordContextProvider,
  ReferenceField,
  SelectField,
  SimpleShowLayout,
  TextField,
} from "react-admin";
import EmployeeField from "server/components/Fields/EmployeeField";
import dataProvider from "server/dataProvider";
import { ExamCommitteeMemberTypeChoices } from "utils/choices";
import { useNotifyError } from "utils/useNotifyError";
import { SectionTitle } from "features/SectionTitle";

const ExamCommiteeSection = ({ examCommitteeId }) => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  const notifyError = useNotifyError();

  const [examCommitteeData, setExamCommitteeData] = useState(null);

  const fetchExamCommitee = useCallback(async () => {
    try {
      const { data } = await dataProvider.customRequest(
        specialistRequests.getExamCommitteeById(examCommitteeId),
        null,
        "GET",
      );
      setExamCommitteeData(data);
    } catch (err) {
      notifyError(err);
    }
  }, [examCommitteeId, notifyError]);

  useEffect(() => {
    if (!examCommitteeId) return;
    fetchExamCommitee();
  }, [examCommitteeId, fetchExamCommitee]);

  if (!examCommitteeData) return null;

  return (
    <RecordContextProvider value={examCommitteeData}>
      <SimpleShowLayout>
        <SectionTitle
          title="Изпитна комисия"
          textAlign="center"
          sx={{ marginTop: "2rem" }}
        />
        <Grid
          container
          spacing={3}
          sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
        >
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Име на изпитна комисия">
              <TextField source="name" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Година">
              <TextField source="year" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Статус">
              <TextField source="statusTextBg" />
            </Labeled>
          </Grid>

          <Grid
            item
            xs={12}
          >
            <Typography
              color="primary"
              fontWeight="bold"
            >
              Членове
            </Typography>
            <ArrayField
              source="members"
              label=""
            >
              <Datagrid
                bulkActionButtons={false}
                rowClick={false}
                sx={[settings.style.detailsDatagrid, { "& .RaDatagrid-headerCell": { textAlign: "left" } }]}
              >
                <SelectField
                  source="type"
                  label="Тип"
                  choices={ExamCommitteeMemberTypeChoices}
                  sortable={false}
                />
                <EmployeeField
                  source="employeeId"
                  label="Служител"
                />
                <TextField
                  source="externalEmployeeNames"
                  label="Имена (външни)"
                  sortable={false}
                  emptyText="-"
                />
              </Datagrid>
            </ArrayField>
          </Grid>

          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Адрес">
              <TextField
                source="contact.address"
                emptyText="-"
              />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Имейл">
              <TextField
                source="contact.email"
                emptyText="-"
              />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Телефон">
              <TextField
                source="contact.phoneNumber"
                emptyText="-"
              />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Мобилен телефон">
              <TextField
                source="contact.mobilePhoneNumber"
                emptyText="-"
              />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Сграда">
              <ReferenceField
                source="contact.buildingId"
                reference={administrationRequests.getBuildingsSelect()}
                emptyText="-"
              >
                <TextField source="name" />
              </ReferenceField>
            </Labeled>
          </Grid>
        </Grid>
      </SimpleShowLayout>
    </RecordContextProvider>
  );
};

export default ExamCommiteeSection;
